import React from 'react'

import logoTextOnly from '../../assets/vectors/logo-text-only.png'

import './LogoWithIcon.scss'

export default () => <img className="logo-with-icon" alt="" src={logoTextOnly} />
